import React, { useState, useEffect, useRef, useCallback } from 'react';
import { Row, Col, Card } from 'react-bootstrap';
import { useParams } from 'react-router-dom';
import ArenaDataService from '../services/arena.service';

const ReplaysList = ({ onClearReplays }) => {
  const [replays, setReplays] = useState([]);
  const { id, place, date, hour } = useParams();
  const videoRefs = useRef([]);

  const trackVideoEvent = useCallback((eventName, replayData) => {
    if (typeof window !== 'undefined' && window.dataLayer) {
      window.dataLayer.push({
        event: eventName,
        video_name: `replaypro_${replayData.replayDate}_${replayData.replayHour}`,
        video_duration: replayData.duration || 0,
        arena_id: id,
        place_name: place,
        event_date: new Date().toISOString()
      });
    }
  }, [id, place]);

  const trackDownload = useCallback((replayData) => {
    if (typeof window !== 'undefined' && window.dataLayer) {
      window.dataLayer.push({
        event: 'video_download',
        video_name: `replaypro_${replayData.replayDate}_${replayData.replayHour}`,
        arena_id: id,
        place_name: place,
        download_date: new Date().toISOString()
      });
    }
  }, [id, place]);

  useEffect(() => {
    if (onClearReplays) {
      onClearReplays(() => setReplays([]));
    }
  }, [onClearReplays]);

  useEffect(() => {
    if (id && place && date && hour) {
      setReplays([]);
      getReplays(id, place, date, hour);
    }
  }, [id, place, date, hour, onClearReplays]);

  useEffect(() => {
    // Configura os event listeners para os vídeos
    videoRefs.current.forEach((video, index) => {
      if (video && replays[index]) {
        video.onplay = () => trackVideoEvent('video_play', replays[index]);
        video.onended = () => trackVideoEvent('video_complete', replays[index]);
        video.ontimeupdate = () => {
          const progress = Math.floor((video.currentTime / video.duration) * 100);
          if (progress === 25 || progress === 50 || progress === 75) {
            trackVideoEvent(`video_progress_${progress}`, replays[index]);
          }
        };
      }
    });

    return () => {
      // Limpa os event listeners ao desmontar
      videoRefs.current.forEach(video => {
        if (video) {
          video.onplay = null;
          video.onended = null;
          video.ontimeupdate = null;
        }
      });
    };
  }, [replays, trackVideoEvent]);

  const getReplays = (arenaId, placeName, date, hour) => {
    ArenaDataService.getReplays(arenaId, placeName, date, hour)
      .then(response => {
        setReplays(response.data);
        videoRefs.current = new Array(response.data.length).fill(null);
      })
      .catch(e => {
        console.log(e);
      });
  };

  return (
    <div>
      <Row>
        {replays.length > 0 ? (
          replays.map((replay, index) => (
            <Col key={index} className="col-12 col-xl-6 mt-4">
              <Card className="flex-fill replay-card">
                <Card.Body>
                  <Card.Title className="arena-logo">
                    <video 
                      width="100%" 
                      controls
                      ref={el => videoRefs.current[index] = el}
                    >
                      <source src={replay.filePath} type="video/mp4" />
                    </video>
                  </Card.Title>
                  <Card.Subtitle className="replay-download">
                    <span>{replay.replayHour}</span>
                    <span>
                      <a 
                        href={replay.filePath} 
                        download={`replaypro_${replay.replayDate}_${replay.replayHour}.mp4`}
                        onClick={() => trackDownload(replay)}
                      >
                        Download
                      </a>
                    </span>
                  </Card.Subtitle>
                </Card.Body>
              </Card>
            </Col>
          ))
        ) : (
          <Col className="col-12 text-center pt-4">
            <div>Escolha um horário para listar os replays disponíveis.</div>
          </Col>
        )}
      </Row>
    </div>
  );
};

export default ReplaysList;